import type { ThemeMode } from '@store/appConfig/types';
import type { ColorsMap, IPaletteThemeProperties } from '@themes/types/theme';

import { getColorsTree } from '@themes/utils/getColorsTree';

// Main orange - primaryColors[5] (#f6901d)
// Orbit grey bg - primaryColors[0] (#eff2f4)
// Text and inputs border/placeholder - primaryColors[8] (#1c4d5c)
// Main green, buttons background - successColors[2] (#00bc57)
// DateTime Pickers green - successColors[1] (#3cd4a0)
// Error - errorColors[5] (#f44336)
// Blue text - infoColors[2] (#536dfe)
// List item hover - infoColors[4] (#afcad7)`

const PlatformTheme = (mode: ThemeMode): IPaletteThemeProperties => {
  const colorsMap: ColorsMap = {
    contrastText: {
      dark: ['#fff'],
      light: ['#fff'],
    },
    contrastBackground: {
      light: ['#fff'],
      dark: ['#141414'],
    },
    warning: {
      dark: ['#342c1a', '#836611', '#dda705', '#e9bf28', '#f8e577'],
      light: ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900'],
    },
    success: {
      dark: ['#1a2721', '#3cd4a0', '#00bc57', '#1da65d', '#61ca8b'],
      light: ['#E0F5EA', '#3cd4a0', '#00bc57', '#00A04D', '#008D3A'],
    },
    info: {
      dark: ['#141414', '#11595f', '#536dfe', '#1ea6aa', '#afcad7', '#ffffff'],
      light: ['#e7ecf1', '#26B0BA', '#536dfe', '#009AA7', '#afcad7', '#141414'],
    },
    primary: {
      dark: [
        '#141414',
        '#f2d1b9',
        '#e9b28a',
        '#e0935b',
        '#d97b38',
        '#d26415',
        '#cd5c12',
        '#c7520f',
        '#fff',
        '#b63606',
      ],
      light: [
        '#eff2f4',
        '#fee9b9',
        '#fdda8a',
        '#fccb5b',
        '#fcbf37',
        '#f6901d',
        '#f6901d',
        '#faa40e',
        '#1c4d5c',
        '#f88c06',
      ],
    },
    error: {
      dark: [
        '#fde6e5',
        '#f9c1bd',
        '#f69891',
        '#f26f65',
        '#ef5044',
        '#ff5c93',
        '#f44336',
        '#e7251a',
        '#e41f15',
        '#df130c',
      ],
      light: [
        '#fde6e5',
        '#f9c1bd',
        '#f69891',
        '#f26f65',
        '#ef5044',
        '#ff5c93',
        '#f44336',
        '#e7251a',
        '#e41f15',
        '#df130c',
      ],
    },
  };

  return getColorsTree({
    mode,
    colorsMap,
  });
};

export default PlatformTheme;
